import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../../orpc'

export function useCrewCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useCrewQuickAdd() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.quickAdd.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useCrewUpdate(crewId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.update.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

// Set (or clear) the crew member's profile photo S3 key.
export function useCrewSetPhoto() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.setPhoto.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

// Attach / detach a photo on one of the crew member's preference sections.
export function useCrewAddPreferencePhoto() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.addPreferencePhoto.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useCrewRemovePreferencePhoto() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.removePreferencePhoto.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useCrewDelete(crewId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.getAll.key() })
        queryClient.invalidateQueries({ queryKey: orpc.crew.getById.key({ input: { id: crewId } }) })
      },
    })
  )
}

export function useCrewDeactivateMe() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.crew.deactivateMe.mutationOptions())
}

export function useCrewCheckEmailExists() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.crew.checkEmailExists.mutationOptions())
}

export function useCrewResendInvite() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.crew.resendInvite.mutationOptions())
}

export function useCrewResendAllInvites() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.crew.resendAllInvites.mutationOptions())
}

export function useCrewRestore() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.restore.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}

export function useCrewSetAdmin() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.crew.setAdmin.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.crew.key() })
      },
    })
  )
}
